import { imperialTimezones } from '@/data/models/ImperialTimezones'

export function cloneVariables(variables) {
  const newObject = { ...variables }

  if (variables.SETS) {
    newObject.SETS = variables.SETS.map(v => ({ ...v }))
  }

  return newObject
}

export function convertWeightByTimezone(weight, timezone, toLBS = false) {
  if (weight === null) return null

  if (imperialTimezones.includes(timezone)) {
    return toLBS ? parseFloat((weight * 2.20462).toFixed(1)) : parseFloat((weight / 2.20462).toFixed(2))
  }

  return weight
}

export function weightSuffix(timezone) {
  if (imperialTimezones.includes(timezone)) {
    return 'lbs'
  }

  return 'kg'
}
